import { IBaseResult } from '../base/BaseModel';

export interface LoginRequest {
  username: string;
  password: string;
}

export interface RegisterRequest {
  username: string;
  password: string;
  email: string;
}
export interface RegisterResponse {
  id: string;
  username: string;
  email: string;
}
export interface LoginResponse {
  id: number;
  username?: string;
  userName?: string; // Backend camelCase
  jwtToken: string;
}

export interface RegisterFormValues {
  name: string;
  email: string;
  password: string;
  confirmPassword: string;
}

export const registerInitialValues: RegisterFormValues = {
  name: '',
  email: '',
  password: '',
  confirmPassword: '',
};

export interface ForgotPasswordFormValues {
  email: string;
}

export const forgotPasswordInitialValues: ForgotPasswordFormValues = {
  email: '',
};
